import { checkGuard } from './guard';
import { useHistory } from 'utils/history';
import { useSession } from 'domains/core/session';

const useGuard = guard => checkGuard(guard, useHistory(), useSession());

export default useGuard;
